/* LEVELEN PDP / collection v2 helpers. Read-only with respect to the cart: nothing here submits forms or changes variants. */
(function () {
  function pickerValue() {
    var vp = document.querySelector('variant-picker');
    if (!vp) return '';
    var r = vp.querySelector('input[type="radio"]:checked');
    if (r) return (r.value || '').trim();
    var s = vp.querySelector('select');
    return s && s.options[s.selectedIndex] ? (s.options[s.selectedIndex].value || '').trim() : '';
  }
  function levelOf(txt) { var m = /level\s*([345])/i.exec(txt || ''); return m ? m[1] : ''; }

  /* Mix buy-box facts + nutrition panel follow the selected Level */
  function syncMix(lv) {
    document.querySelectorAll('[data-lvx-mix]').forEach(function (el) {
      var data; try { data = JSON.parse(el.getAttribute('data-lvx-mix')); } catch (e) { return; }
      var d = data[lv]; if (!d) return;
      el.querySelectorAll('[data-f]').forEach(function (f) { var k = f.getAttribute('data-f'); if (d[k] != null) f.textContent = d[k]; });
      el.querySelectorAll('[data-lv]').forEach(function (s) { s.classList.toggle('on', s.getAttribute('data-lv') === lv); });
    });
    setNutrition(lv, false);
    syncCross(lv);
  }
  /* "Mix it up" cards follow the selected Level (link, label, price, image) */
  function syncCross(lv) {
    document.querySelectorAll('[data-lvx-xc]').forEach(function (a) {
      var map; try { map = JSON.parse(a.getAttribute('data-lvx-xc')); } catch (e) { return; }
      var d = map['Level ' + lv]; if (!d) return;
      a.href = d.u;
      var t = a.querySelector('[data-xc-t]'); if (t) t.textContent = d.t;
      var img = a.querySelector('img');
      if (img && d.i) { img.removeAttribute('srcset'); img.src = d.i; }
    });
  }
  /* Recommendation line hides when that option is already selected */
  function syncRec(v) {
    document.querySelectorAll('[data-lvx-rec]').forEach(function (p) { p.hidden = p.getAttribute('data-lvx-rec') === v; });
  }
  /* Judge.me renders an empty "Product reviews (0) ... No items found" box when there are no reviews; hide its section until reviews exist */
  function hideEmptyReviews() {
    document.querySelectorAll('#judgeme_product_reviews, .jdgm-review-widget').forEach(function (w) {
      var sec = w.closest('.shopify-section') || w.closest('[id^="shopify-section"]'); if (!sec) return;
      var txt = w.textContent || '';
      var empty = /Product reviews\s*\(0\)/i.test(txt) && !/Store reviews\s*\([1-9]/i.test(txt);
      if (empty) sec.style.display = 'none'; else if (sec.style.display === 'none') sec.style.display = '';
    });
  }
  function setNutrition(lv, fromUser) {
    document.querySelectorAll('[data-lvx-nf]').forEach(function (nf) {
      if (!fromUser && nf.getAttribute('data-user') === '1') return;
      nf.querySelectorAll('[data-lvl-only]').forEach(function (x) { x.hidden = x.getAttribute('data-lvl-only') !== lv; });
      nf.querySelectorAll('[data-nf-btn]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-nf-btn') === lv ? 'true' : 'false'); });
    });
  }

  /* Sweat test value math follows the selected kit option */
  function syncKit(txt) {
    document.querySelectorAll('[data-lvx-kit]').forEach(function (el) {
      var shown = false;
      el.querySelectorAll('[data-for]').forEach(function (p) {
        var match = p.getAttribute('data-for') === txt;
        p.hidden = !match; if (match) shown = true;
      });
      el.hidden = !shown;
    });
  }

  var last = null;
  function sync() {
    var v = pickerValue();
    if (v === last) return;
    last = v;
    var lv = levelOf(v);
    if (lv) syncMix(lv);
    if (document.querySelector('[data-lvx-kit]')) syncKit(v);
    syncRec(v);
  }

  /* Tabs */
  function initTabs() {
    document.querySelectorAll('[data-lvx-tabs]').forEach(function (t) {
      var btns = t.querySelectorAll('[role="tab"]');
      function show(i) {
        btns.forEach(function (b, j) {
          var on = i === j; b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
          var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = !on;
        });
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { show(i); });
        b.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault(); var n = (i + (e.key === 'ArrowRight' ? 1 : btns.length - 1)) % btns.length; show(n); btns[n].focus();
          }
        });
      });
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-nf-btn]');
      if (!b) return;
      var nf = b.closest('[data-lvx-nf]'); nf.setAttribute('data-user', '1');
      var lv = b.getAttribute('data-nf-btn');
      nf.querySelectorAll('[data-lvl-only]').forEach(function (x) { x.hidden = x.getAttribute('data-lvl-only') !== lv; });
      nf.querySelectorAll('[data-nf-btn]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    });
  }

  /* Collection: pick a Level, product cards link straight to that Level's variant */
  function initCollection() {
    var root = document.querySelector('[data-lvx-col]'); if (!root) return;
    var sel = root.querySelector('[data-lvx-selmsg]');
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-pick]'); if (!t) return;
      var lv = t.getAttribute('data-pick');
      var on = t.getAttribute('aria-pressed') !== 'true';
      root.querySelectorAll('[data-pick]').forEach(function (b) { b.setAttribute('aria-pressed', on && b === t ? 'true' : 'false'); });
      root.querySelectorAll('[data-card]').forEach(function (c) {
        var a = c.querySelector('[data-href]'); var base = a.getAttribute('data-href');
        var vid = on ? c.getAttribute('data-v' + lv) : '';
        c.querySelectorAll('a').forEach(function (x) { x.href = vid ? base + '?variant=' + vid : base; });
        var chip = c.querySelector('[data-chip]');
        if (chip) { chip.hidden = !(on && vid); chip.textContent = 'Level ' + lv; chip.className = 'chip c' + lv; }
        var cta = c.querySelector('[data-cta]'); if (cta) cta.textContent = on && vid ? 'Shop Level ' + lv : cta.getAttribute('data-default');
      });
      if (sel) sel.innerHTML = on ? 'Showing every flavor at <b>Level ' + lv + '</b>. Tap it again to clear.' : '';
    });
  }

  /* Sweat Test kit picker: two explicit choices that click Horizon's own variant radios.
     The server renders the initial state from the selected variant; nothing is auto-selected after load. */
  function initKitPicker() {
    var first = document.querySelector('[data-lvx-kp]'); if (!first) return;
    function kp() { return document.querySelector('[data-lvx-kp]') || first; }
    function radioFor(val) {
      var vp = document.querySelector('variant-picker'); if (!vp || !val) return null;
      var rs = vp.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < rs.length; i++) if ((rs[i].value || '').trim() === val) return rs[i];
      return null;
    }
    var d = first.dataset;
    if (!radioFor(d.end) || !radioFor(d.endSt) || !radioFor(d.single) || !radioFor(d.singleSt)) return;
    document.body.classList.add('lvx-kp-on');
    function state() {
      var v = pickerValue(), k = kp().dataset;
      return { sport: (v === k.single || v === k.singleSt) ? 'single' : 'end', starter: (v === k.endSt || v === k.singleSt) };
    }
    function render() {
      var s = state();
      document.querySelectorAll('[data-lvx-kp]').forEach(function (el) {
        var k = el.dataset, single = s.sport === 'single';
        el.querySelectorAll('[data-kp-sport]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-kp-sport') === s.sport ? 'true' : 'false'); });
        el.querySelectorAll('[data-kp-kit]').forEach(function (b) { b.setAttribute('aria-pressed', (b.getAttribute('data-kp-kit') === 'starter') === s.starter ? 'true' : 'false'); });
        var pt = el.querySelector('[data-kp-p="test"]'); if (pt) pt.textContent = single ? k.pSingle : k.pEnd;
        var ps = el.querySelector('[data-kp-p="starter"]'); if (ps) ps.textContent = single ? k.pSingleSt : k.pEndSt;
        var base = k.url + '?variant=';
        el.querySelectorAll('[data-kp-sport]').forEach(function (b) { var sg = b.getAttribute('data-kp-sport') === 'single'; b.href = base + (sg ? (s.starter ? k.idSingleSt : k.idSingle) : (s.starter ? k.idEndSt : k.idEnd)); });
        el.querySelectorAll('[data-kp-kit]').forEach(function (b) { var st = b.getAttribute('data-kp-kit') === 'starter'; b.href = base + (single ? (st ? k.idSingleSt : k.idSingle) : (st ? k.idEndSt : k.idEnd)); });
        var val = el.querySelector('[data-kp-val]');
        if (val) { val.textContent = single ? k.vSingle : k.vEnd; val.hidden = !s.starter; }
      });
    }
    function choose(sport, starter) {
      var k = kp().dataset;
      var v = sport === 'single' ? (starter ? k.singleSt : k.single) : (starter ? k.endSt : k.end);
      var r = radioFor(v); if (r && !r.checked) r.click();
      setTimeout(render, 0); setTimeout(render, 400);
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var o = e.target.closest('[data-kp-sport]');
      if (o) { e.preventDefault(); choose(o.getAttribute('data-kp-sport'), state().starter); return; }
      var t = e.target.closest('[data-kp-kit]');
      if (t) { e.preventDefault(); choose(state().sport, t.getAttribute('data-kp-kit') === 'starter'); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== ' ' || !e.target.closest) return;
      var b = e.target.closest('[data-kp-sport],[data-kp-kit]'); if (b) { e.preventDefault(); b.click(); }
    });
    render(); setInterval(render, 700);
    initEstimate();
  }

  /* Optional quiz estimate: ?loss_low=&loss_high=&intake= (mg sodium per hour, integers 0 to 6000) */
  function initEstimate() {
    var card = document.querySelector('[data-lvx-est]'); if (!card) return;
    var q; try { q = new URLSearchParams(location.search); } catch (e) { return; }
    function num(name) {
      var v = (q.get(name) || '').trim();
      if (!/^\d{1,4}$/.test(v)) return null;
      var n = parseInt(v, 10); return n >= 0 && n <= 6000 ? n : null;
    }
    var lo = num('loss_low'), hi = num('loss_high'), intake = num('intake');
    if (lo === null || hi === null) return;
    if (lo > hi) { var x = lo; lo = hi; hi = x; }
    function f(n) { return n.toLocaleString('en-US'); }
    var txt = 'You likely lose about ' + f(lo) + ' to ' + f(hi) + ' mg of sodium an hour';
    txt += intake !== null ? ' and take in about ' + f(intake) + ' mg. ' : '. ';
    txt += 'A sweat test measures your real number.';
    card.querySelector('[data-lvx-est-t]').textContent = txt;
    card.hidden = false;
  }

  function init() {
    initTabs(); initCollection(); initKitPicker(); sync();
    document.addEventListener('change', function () { setTimeout(sync, 0); });
    document.addEventListener('variant:update', function () { setTimeout(sync, 0); });
    setInterval(sync, 700);
    hideEmptyReviews(); var n = 0, ri = setInterval(function () { hideEmptyReviews(); if (++n > 60) clearInterval(ri); }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
